import { toFormat, fromFormat, toShortYearInterval, getNow, toISODate, preferenceToLuxonFormat } from './date';
import { parseMultiFormatsDate } from './multiFormatsParser';

const DatesService = {
  toFormat,
  fromFormat,
  toShortYearInterval,
  getNow,
  toISODate,
  preferenceToLuxonFormat,
  parseMultiFormatsDate,
};

export default DatesService;
